export default __webpack_public_path__ + "img/sidebar_report.b2d42480.svg";